module.exports = __webpack_public_path__ + "static/media/greenTheme-girl.972303be.svg";